import React from 'react';

import lang from '../../../lang';

class JSPDFGenerate extends React.Component {
  render() {
    window.localStorage.setItem('pdftitle',this.props.pdfTitle);
    const headerKeys = [];

    this.props.columnlist.map((_row, ind) => headerKeys.push(lang.langCheck.langRequest(_row.field)));

    const csvData = this.props.dataList.map((elt) => {
      const dataObj = {};
      for (let i = 0; i < headerKeys.length; i++) {
        const ele = headerKeys[i];
        dataObj[ele] = elt[ele];
      }
      return dataObj;
    });
    return (
      <table id="basic-table" style={{ display: 'none' }}>
         {/* <thead>
          <tr>
            <th colSpan={(this.props.columnlist.length)} style={{border:"1px solid", textAlign: "center" }}>{this.props.pdfTitle}</th>
            </tr>
         </thead> */}
        <thead>
          <tr >
            {this.props.columnlist.map((_r, k) => <th key={k}>{lang.langCheck.langRequest(_r.field)}</th>)}
          </tr>
        </thead>
        <tbody>
          {csvData.map((_row, j) => (
            <tr key={j}>
              {
                 headerKeys.map((_k, i) => <td key={i}>{_row[_k]}</td>)
             }
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default JSPDFGenerate;
